import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import DreamConstructor from './DreamConstructor';
import VRon from './VRon';
import VRonInfiniteWorld from './VRonInfiniteWorld';
import VRonItisa from './VRonItisa';
import VRonItisaloop from './VRonItisaloop';
import VRonEndofloop from './VRonEndofloop';
import Detective from './Detective';
import Auth from './Auth';
import UserContext from './UserContext';
import ProtectedRoute from './ProtectedRoute';  // Import ProtectedRoute
import './App.css';
import { auth } from './firebase';  // Import necessary Firebase functions
import { onAuthStateChanged } from 'firebase/auth';

function App() {
  const [user, setUser] = useState(null);
  // False until Firebase has told us once whether someone is signed in.
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
        if (currentUser) {
            setUser(currentUser);  // Update the user in context
        } else {
            setUser(null);
        }
        setAuthReady(true);
    });

    // Cleanup the listener on component unmount
    return () => unsubscribe();
  }, []);

  return (
    <div className="App">
      <UserContext.Provider value={{ user, setUser, authReady }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<Auth />} />
            {/* Use ProtectedRoute for routes that need protection */}
            <Route 
              path="/memorykeeper" 
              element={
                <ProtectedRoute>
                  <DreamConstructor />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/memorykeeper/:searchTerm" 
              element={
                <ProtectedRoute>
                  <DreamConstructor />
                </ProtectedRoute>
              } 
            />
            {/* Add other routes as needed */}
            <Route
              path="/vron"
              element={
                <ProtectedRoute>
                  <VRon />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vron/infinite-world"
              element={
                <ProtectedRoute>
                  <VRonInfiniteWorld />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vron/it-is-a-loop"
              element={
                <ProtectedRoute>
                  <VRonItisaloop />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vron/it-is-a"
              element={
                <ProtectedRoute>
                  <VRonItisa />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vron/end-of-loop"
              element={
                <ProtectedRoute>
                  <VRonEndofloop />
                </ProtectedRoute>
              }
            />
            <Route
              path="/detective"
              element={
                <ProtectedRoute>
                  <Detective />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </UserContext.Provider>
    </div>
  );
}

export default App;
